const urlParams = new URLSearchParams(window.location.search)
const discountCode = urlParams.get('discount')

const discountPercentage = {
	'CHAMBERLIN': 20,
	'KELLYROSESARNO': 20,
	'BRANDIPOPE': 20,
	'DRCASALE': 20,
	'ARIANEMANN': 20,
	'WOLSKI': 20,
	'MULLIN': 20,
	'MALEK': 20,
	'BLONDE25': 20,
	'SAKSHI': 20,
	'DAFNE': 20,
	'AVERITT': 20,
}

const parseCurrency = (value) => {
  const pattern = /[\s]*[^\d]*([\d,]*\.\d{1,2})|([\d,]+)/
  const match = value.match(pattern)
  if (!match) return null
  const numberString = (match[1] || match[2]).replace(/,/g, '')
  return parseFloat(numberString)
}

const parseDiscountCode = (value) => {
	const chunks = value.trim().split(' ')
	return chunks.length > 0 ? chunks[0].trim().toLocaleUpperCase() : ''
}

const renderCartDrawerFooter = () => {
	return fetch(window.Shopify.routes.root + "?sections=cart-drawer")
		.then((res) => res.json())
		.then((data) => {
			const cartDrawerFooterElement = document.querySelector(".cart-drawer__footer")
			const parser = new DOMParser()
			const doc = parser.parseFromString(data["cart-drawer"], "text/html")
			const cartDrawerFooter = doc.querySelector(".cart-drawer__footer")
			cartDrawerFooterElement.replaceWith(cartDrawerFooter)
		}).catch(error => {
			throw new Error(error)
    })
}

const renderAnnouncementBar = (percentage) => {
	if (!percentage) return

	const announcementBarEl = document.querySelector("#shopify-section-announcement-bar .container")
	
	if (!announcementBarEl) return
	
	announcementBarEl.innerHTML = `
		<div>
			<p>
				Your
				<strong>${percentage}%</strong>
				Coupon Has Been Applied
			</p>
		</div>
	`
}

const extractCartDiscountPercentage = () => {
	const cartDrawerFooterEl = document.querySelector(".cart-drawer__footer")
	const cartDrawerDiscountEl = cartDrawerFooterEl?.querySelector(".discounts__discount")
	
	if (!cartDrawerDiscountEl) return

	const cartDiscountCode = parseDiscountCode(cartDrawerDiscountEl.textContent)

	return cartDiscountCode
}

const applyDiscount = async (discountCode) => {
	try {
		const response = await fetch(`/discount/${discountCode}`)
		if (!response.ok) throw new Error('Failed to apply discount.')

		await renderCartDrawerFooter()
	} catch (error) {
		console.log(error.message)
	}
}

const init = async () => {
	if (discountCode) {
		const percentage = discountPercentage[discountCode.toLocaleUpperCase()]
		renderAnnouncementBar(percentage)
		await applyDiscount(discountCode)
	}
	else {
		const percentage = discountPercentage[extractCartDiscountPercentage()]
		renderAnnouncementBar(percentage)
	}
}

init()
